import cn from "classnames"

import { Divider, Flex, Link, Popover, Text } from "@/atoms"
import { ArrowRightOutlined } from "@/icons"
import { FalsePositiveLabel } from "@/organisms/Drawers/components/TriageDrawer/components/KaiFix/components/FalsePositiveLabel"
import { getDescription } from "./helpers"

import styles from "./TestImpactFormSection.module.scss"

import type { IssueTestImpactProps } from "."

export const IssueTestImpact = (props: IssueTestImpactProps) => {
  const { item, t } = props
  const { cwe, filePath, link, before, after, coordinate } = item
  const { url, displayText = filePath } = link || {}

  return (
    <Flex justify="space-between" gap={100} className={styles.issue}>
      <Flex vertical flex={1} className={styles.minW0}>
        <Text ellipsis>{cwe.description}</Text>
        <Popover
          content={
            <Flex vertical>
              <Flex gap={4} align="center">
                <span>{`${t(`issue.source`)}:`}</span>
                {url && (
                  <Link href={url} type="link-hover" target="_blank">
                    {displayText}
                  </Link>
                )}
                {!url && <span>{filePath}</span>}
              </Flex>
              <Flex align="center">
                <span>{`${t(`issue.line`)}: ${coordinate.startLine}`}</span>
                <Divider
                  orientation="vertical"
                  className={styles.popoverDivider}
                />
                <span>{`${t(`issue.column`)}: ${coordinate.startColumn}`}</span>
              </Flex>
            </Flex>
          }
        >
          <Flex>
            <Text
              ellipsis
              type="secondary"
              className="sm-text-ks"
            >{`${cwe.id} on ${filePath}`}</Text>
            <Text type="secondary" className={cn("sm-text-ks", styles.noWrap)}>
              {`#L${coordinate.startLine}C${coordinate.startColumn}`}
            </Text>
          </Flex>
        </Popover>
      </Flex>
      <Flex gap={12} align="center" className={styles.issueWrapper}>
        <FalsePositiveLabel
          isFalsePositive={before.isFalsePositive}
          description={getDescription(before)}
        />
        <ArrowRightOutlined className={styles.issueArrowIcon} />
        <FalsePositiveLabel
          isFalsePositive={after.isFalsePositive}
          description={getDescription(after)}
        />
      </Flex>
    </Flex>
  )
}
